export default __webpack_public_path__ + "static/media/learn_01.b8645ddc.jpeg";